export enum UnitTypeCategory {
  Weight = 'weight',
  Volume = 'volume',
  Length = 'length',
  PackType = 'pack_type',
}

// S.I. units
export enum BaseUnitKind {
  Meter = 'meter',
  Liter = 'liter',
  Kilogram = 'kilogram',
  Pallet = 'pallet',
  CubicMeter = 'cubic_meter',
  Box = 'box',
  Bag = 'bag',
  Roll = 'roll',
  Sheet = 'sheet',
  Tube = 'tube',
  Other = 'other',
  Piece = 'piece',
}